import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Card from "../Components/Card";
import axios from "axios";


function Home() {

    const [search, setSearch] = useState('')
    const [foodData, setfoodData] = useState([])

    const [foodCategory, setfoodCategory] = useState([])

    const handleApi = async (e) => {
        // e.preventDefault();
        let x = await axios.get('https://gofoodies.onrender.com/getFoodCategory')
            .then(result => {
                // console.log(result.data.data)
                let Data1 = result.data.data
                return Data1
            })
            .catch(err => {
                console.log(err.response.data.msg)
                alert(err.response.data.msg)
            })

        let y = await axios.get('https://gofoodies.onrender.com/getAllFoodData')
            .then(result => {
                // console.log(result.data.data)
                let Data2 = result.data.data
                return Data2
            })
            .catch(err => {
                console.log(err.response.data.msg)
                alert(err.response.data.msg)
            })

        // console.log(x)
        // console.log(y)
        setfoodCategory(x)
        setfoodData(y)



    }


    useEffect(() => {
        handleApi()
    }, [])


    return (
        <div>
            <div><Navbar /></div>
            <div>

                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel" style={{ objectFit: 'contain !important' }}>
                    <div className="carousel-inner" id='carousel'>

                        <div className='carousel-caption d-none d-md-block' style={{ zIndex: "10" }}>
                            <div class="d-flex justify-content-center">
                                <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
                                {/* <button class="btn btn-outline-success bg-success text-white" type="submit">Search</button> */}
                            </div>

                        </div>


                        <div className="carousel-item active">
                            <img src={'https://source.unsplash.com/random/900×300/?burger'} className="d-block w-100" style={{ filte: "brightness(30%)", objectFit: "fill" }} alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={'https://source.unsplash.com/random/900×300/?pastry'} className="d-block w-100" style={{ filte: "brightness(30%)", objectFit: "fill" }} alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={'https://source.unsplash.com/random/900×300/?samosha'} className="d-block w-100" style={{ filte: "brightness(30%)", objectFit: "fill" }} alt="..." />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>

            </div>


            <div className="container " id="conta">

                {
                    foodCategory.map((data) => {
                        return (
                            <div className="row mb-3" id="cat">
                                <div key={data._id} className="fs-3 m-3 ">
                                    {data.CategoryName}
                                </div>
                                <hr />

                                {
                                    foodData.filter((items) => (items.CategoryName === data.CategoryName) && (items.name.toLowerCase().includes(search)))
                                        .map((filters) => {
                                            const { options } = filters
                                            return (
                                                <div key={filters._id} className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 " id="d">
                                                    <Card foodItems={filters} options={options[0]}/>
                                                    
                                                </div>
                                               
                                            )
                                        })
                                }

                            </div>
                        )
                    })
                }

            </div>

            <div><Footer /></div>
        </div>
    );
}

export default Home;
